export default defineNuxtPlugin(() => {
  const url = useRuntimeConfig().public.goatcounterUrl;
  if (!url) return;
  useHead({ script: [{
    "data-goatcounter": url,
    async: true,
    src: "https://gc.zgo.at/count.js",
  }] });
});
